/**
 * Reparto en bloques (D23): numProductos define el tamaño; el último bloque puede
 * quedar incompleto y se acepta así.  8 con 3 espacios → [1,2,3] [4,5,6] [7,8].
 */
export function repartirEnBloques(items, numProductos) {
    if (numProductos < 1)
        throw new RangeError(`numProductos inválido: ${numProductos}`);
    const bloques = [];
    for (let i = 0; i < items.length; i += numProductos) {
        bloques.push(items.slice(i, i + numProductos));
    }
    return bloques;
}
function centroDe(rects) {
    const minX = Math.min(...rects.map((r) => r.x));
    const minY = Math.min(...rects.map((r) => r.y));
    const maxX = Math.max(...rects.map((r) => r.x + r.w));
    const maxY = Math.max(...rects.map((r) => r.y + r.h));
    return { cx: (minX + maxX) / 2, cy: (minY + maxY) / 2 };
}
/**
 * Bloque incompleto (D36): los elementos `producto`/`precio` sin datos se ocultan y los
 * restantes se RECENTRAN dentro del bounding box que ocupaban los tres, conservando
 * tamaño y espaciado. Nada se reescala: un producto solo no sale gigante.
 */
export function recentrarBloqueIncompleto(elementos, presentes) {
    const conIndice = elementos.filter((e) => e.tipo === 'producto' || e.tipo === 'precio');
    if (conIndice.length === 0)
        return elementos;
    const todos = conIndice.map((e) => e.rect);
    const visibles = conIndice.filter((e) => presentes.has(e.indice));
    if (visibles.length === 0 || visibles.length === conIndice.length) {
        // Bloque completo o vacío: nada que recentrar; sólo se ocultan los sin datos.
        return elementos.map((e) => (e.tipo === 'producto' || e.tipo === 'precio') && !presentes.has(e.indice)
            ? { ...e, visible: false }
            : e);
    }
    const centroTotal = centroDe(todos);
    const centroVisibles = centroDe(visibles.map((e) => e.rect));
    const dx = centroTotal.cx - centroVisibles.cx;
    const dy = centroTotal.cy - centroVisibles.cy;
    return elementos.map((e) => {
        if (e.tipo !== 'producto' && e.tipo !== 'precio')
            return e;
        if (!presentes.has(e.indice))
            return { ...e, visible: false };
        // Traslación pura del grupo: mismo tamaño, mismo espaciado (D36).
        return { ...e, rect: { ...e.rect, x: e.rect.x + dx, y: e.rect.y + dy } };
    });
}
//# sourceMappingURL=reparto.js.map